export var CallType;
(function (CallType) {
    CallType[CallType["INBOUND"] = 10] = "INBOUND";
    CallType[CallType["OUTBOUND"] = 20] = "OUTBOUND";
    CallType[CallType["CALLBACK"] = 30] = "CALLBACK";
})(CallType || (CallType = {}));
//# sourceMappingURL=call-type.js.map